/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Txn } from '@src/app/model/txn';
import { Field } from '@src/app/shared/field/Field';
import { FormDateComponent } from '@src/app/shared/form/form-date/form-date.component';
import { FormNumberComponent } from '@src/app/shared/form/form-number/form-number.component';
import { FormPicklistComponent } from '@src/app/shared/form/form-picklist/form-picklist.component';
import { CycleService } from '@src/app/modules/budget/cycle.service';
import { PeriodService } from '@src/app/modules/budget/period.service';
import { UnitService } from '@src/app/modules/unit/unit.service';
import { PersonService } from '@src/app/pages/person-page/person.service';
import { BCodeService } from '@src/app/modules/budget/bcode.service';
import { FieldMaker } from '@src/app/shared/field/FieldMaker';
import { FormTextAreaComponent } from '@src/app/shared/form/form-text-area/form-text-area.component';
import { FormTextComponent } from '@src/app/shared/form/form-text/form-text.component';
import { MyInjector } from '@src/app/app.module';

@Injectable({
    providedIn: 'root'
})
export class ApDetailTxnService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);
    protected unitSvc = inject(UnitService);
    personSvc = inject(PersonService);
    protected cycleSvc = inject(CycleService);
    protected periodSvc = inject(PeriodService);
    protected bCodeSvc = inject(BCodeService);


    protected get baseUrl() {
        return this.getAjaxPath('txn/purchaseDetail');
    }
    protected cache: Txn[];
    protected typeString = 'Txn';

    getFields(): Field[] {
        const cycleSvc = MyInjector.instance.get(CycleService);
        return [
            FieldMaker.idHolder('id'),
            FieldMaker.rev(),
            FormTextComponent.make('Ref', 'refNr'),
            FormTextComponent.make('Parent', 'parentRefNr'),
            FormPicklistComponent.make('Cycle', 'txnCycleId', null, { service: cycleSvc}),
            FormPicklistComponent.make('Period', 'txnPeriodId', 'periodName', { selfPopulate: true }),
            FormDateComponent.make('Transaction Date', 'txnDate', { cellOpts: { width: '2%' }, formColumn: 2 }),
            FormPicklistComponent.make('Budget Code', 'bCodeId', 'bCodeName', { selfPopulate: true }),
            FormPicklistComponent.make('Type', 'typeId', 'typeName', { selfPopulate: true }),

            FormPicklistComponent.make('Supplier', 'supplierId', 'supplierName', { selfPopulate: true }),
            FormTextAreaComponent.make('Notes', 'notes', { maxLength: 10 }),
            FormTextAreaComponent.make('Parent Notes', 'parentNotes', {maxLength: 10}),
            FormNumberComponent.makeCurrency('Debit', 'debit'),
            FormNumberComponent.makeCurrency('Credit', 'credit'),
            FormNumberComponent.makeCurrency('Value', 'txnValue', {visible: Field.noShow})

        ];
    }

}
